import { sync, cancelSync } from '../../frameloop/index.mjs';

const frameloopDriver = (update) => {
    const passTimestamp = ({ timestamp }) => update(timestamp);
    return {
        start: () => sync.update(passTimestamp, true),
        stop: () => cancelSync.update(passTimestamp),
        now: () => performance.now(),
    };
};

export { frameloopDriver };
